import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { PERSONAL_DATA_LINK } from '../constants/links';
import { assertCallbackResponseError, assertResponseValidationError } from '../utils/asserts';
import { ValidationError } from '../utils/errors';
import { getTimezoneDiff } from '../utils/time';
export var EFormStatus;
(function (EFormStatus) {
  EFormStatus["Form"] = "form";
  EFormStatus["Success"] = "success";
  EFormStatus["Failure"] = "failure";
})(EFormStatus || (EFormStatus = {}));
export var useCallbackState = function useCallbackState(_ref) {
  var onError = _ref.onError,
    onRequestCallback = _ref.onRequestCallback,
    onSuccess = _ref.onSuccess,
    privacyPolicyUrl = _ref.privacyPolicyUrl,
    timezoneOffset = _ref.timezoneOffset;
  var _React$useState = React.useState(EFormStatus.Form),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    status = _React$useState2[0],
    setStatus = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    callbackDate = _React$useState4[0],
    setCallbackDate = _React$useState4[1];
  var timezoneDiff = typeof timezoneOffset === 'number' ? getTimezoneDiff(timezoneOffset) : 0;
  var privacyPolicyLink = privacyPolicyUrl || PERSONAL_DATA_LINK;
  var handleSuccess = React.useCallback(function () {
    if (onSuccess) {
      onSuccess();
    }
  }, [onSuccess]);
  var handleError = React.useCallback(function (error) {
    if (onError) {
      onError(error);
    }
  }, [onError]);
  var resetState = React.useCallback(function () {
    setStatus(EFormStatus.Form);
    setCallbackDate('');
  }, []);
  var handleRequestCallback = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return onRequestCallback(params);
          case 3:
            result = _context.sent;
            assertResponseValidationError(result, 'callback-widget.useCallbackState.handleRequestCallback()');
            assertCallbackResponseError(result, 'callback-widget.useCallbackState.handleRequestCallback()');
            setCallbackDate(result.date);
            setStatus(EFormStatus.Success);
            handleSuccess();
            _context.next = 17;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            if (!(_context.t0 instanceof ValidationError)) {
              _context.next = 15;
              break;
            }
            throw _context.t0;
          case 15:
            handleError(_context.t0);
            setStatus(EFormStatus.Failure);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 11]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onRequestCallback, handleSuccess, handleError]);
  return {
    callbackDate: callbackDate,
    handleRequestCallback: handleRequestCallback,
    privacyPolicyLink: privacyPolicyLink,
    resetState: resetState,
    status: status,
    timezoneDiff: timezoneDiff
  };
};